import { SystemStyleObject } from '@chakra-ui/react';

export const sectionListSx = (section: number): SystemStyleObject => ({
  counterReset: `section-${section}`,
  '& > li': {
    counterIncrement: `section-${section}`,
    listStyleType: 'none',
    '::marker': {
      content: `"${section}." counter(section-${section}) " "`,
      fontWeight: 'bold',
      fontFamily: 'marketingPage',
    },
  },
});
